import React from 'react';
import ContactInfo from './ContactInfo';
import BankDetails from './BankDetails';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { Link } from 'react-router-dom';

let PersonalInfo = ({ translate, currentLanguage, payment, user }) => {
  const paymentUrl = user && user.newCardUrl && user.newCardUrl !== "" ? user.newCardUrl : `/${currentLanguage}/edit/payment`;
  return (
    <div >
      <div >
        <h1 className="title">{translate('profile')}</h1>
        <ContactInfo />
        {payment.last_cc_numbers ? <BankDetails /> : ''}
        <div className="card card-section" id="actions">
          <div className="card-block">
            <div className="card-title">
              <h3>{translate('Actions')}</h3>
            </div>
            <ul className="list-action">
              <li className="list-action-item">
                <Link to={`/${currentLanguage}/edit/info`} className="btn btn-action" >{translate('change-profile-information')}</Link>
              </li>
              <li className="list-action-item">
                <Link to={`/${currentLanguage}/edit/address`} className="btn btn-action" >{translate('change-profile-address-information')}</Link>
              </li>
              <li className="list-action-item">
                <a href={`${paymentUrl}`} className="btn btn-action" >{translate('change-payment')}</a>
              </li>
              <li className="list-action-item">
                <Link to={`/${currentLanguage}/personalinfo/changepasswod`} className="btn btn-action" >{translate('change-password')}</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    payment: state.User.paymentMethod,
    user: state.User.user
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {

  }
}

PersonalInfo = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(PersonalInfo);


export default PersonalInfo;



// WEBPACK FOOTER //
// ./src/components/InfoPerson/PersonalInfo.js